
<template>
  <!-- 共享看板，我的看板 -->
  <div chass="app-container">
    <div class="chart-container" style="padding-top:10px" v-loading="pageloading">
      <div style="width:100%">
        <el-button @click="drawer = true" slot="reference" size="mini" style="margin-bottom:10px;" v-if="addshow" icon="el-icon-circle-plus-outline">添加</el-button>
        <el-drawer title="" size="300px" :visible.sync="drawer" :before-close="handleClose">
          <el-button type="primary" style="margin-left:10px;padding: 5px 15px;" @click="yingyongliebiao">应用</el-button>

          <el-input v-model="gridDatasousuo" placeholder="请输入内容" size="mini" prefix-icon="el-icon-search" @input="gridDatasousuoinput" style="margin: 10px 20px 0; width: 150px;"></el-input>

          <el-table :data="gridData" :show-header='false' style="margin-top:30px;" :height="tableHeight">
            <el-table-column property="name" label="报表名称" width="220">

              <template slot-scope="scope">
                <div style="width:220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="scope.row[scope.column.property]">
                  {{scope.row[scope.column.property]}}
                </div>
              </template>

            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="mini" style="color:#1890ff" v-if="scope.row.selected == false" @click="handleEditadd(scope.$index, scope.row)">添加</el-button>
                <el-button size="mini" style="color:#EE6363" v-if="scope.row.selected == true" @click="handleEditremove(scope.$index, scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-drawer>

        <el-button @click="drawershared = true" slot="reference" size="mini" style="margin-bottom:10px;" v-if="addshow" icon="el-icon-upload2">共享</el-button>
        <el-drawer title="" size="300px" :visible.sync="drawershared" :before-close="handleCloseshared">
          <el-button type="primary" style="margin-left:10px;padding: 5px 15px;" @click="yingyongliebiaoshared">应用</el-button>
          <div style="margin-top:10px;margin-left:10px">
            <el-select v-model="sharedselectvalue" placeholder="请选择" @change="sharedselectchange">
              <el-option v-for="itemselect in sharedselect" :key="itemselect.value" :label="itemselect.label" :value="itemselect.value">
              </el-option>
            </el-select>
          </div>
          <div v-if="sharedselectvalue == '1'" style="text-align: center;color:#1890ff;margin-top:200px;">
            <svg-icon slot="reference" icon-class="yonghuzu" class="icon" style="width:100px;height:100px;color:#1890ff" />
            <div>仅自己有权限查看看板</div>
          </div>
          <div v-if="sharedselectvalue == '2'" style="text-align: center;color:##1890ff;margin-top:200px;">
            <svg-icon slot="reference" icon-class="yonghuzu" class="icon" style="width:100px;height:100px;color:#1890ff" />
            <div>项目组任何成员都有权限查看看板</div>
          </div>
          <el-table v-if="sharedselectvalue == '3'" :data="gridDatashared.filter(data => !usersearch || data.realname.toLowerCase().includes(usersearch.toLowerCase()))" :show-header='true' style="margin-top:30px;"
            :height="tableHeightshared">
            <el-table-column property="realname" label="姓名" width="200">
              <template slot="header" slot-scope="scope">
                <el-input v-if="gridDatashared.length>0" v-model="usersearch" size="mini" placeholder="输入关键字搜索" />
              </template>
              <template slot-scope="scope">
                <div style="width:220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="scope.row[scope.column.property]">
                  {{scope.row[scope.column.property]}}
                </div>
              </template>

            </el-table-column>
            <el-table-column label="" width="80">
              <template slot-scope="scope">
                <el-button size="mini" style="color:#1890ff" v-if="scope.row.locked == '0'" @click="userhandleEditadd(scope.$index, scope.row)">添加</el-button>
                <el-button size="mini" style="color:#EE6363" v-if="scope.row.locked == '1'" @click="userhandleEditremove(scope.$index, scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-drawer>

        <span style="float:right;color:#789;font-size:14px;margin-bottom:10px">游戏时区：世界时间（{{productTimeZone}}）</span>

        <el-dialog title="报表属性设置" :visible.sync="dialogFormVisible">
          <el-form :model="baobiaoform">
            <el-form-item label="看板名称" :label-width="formLabelWidth">
              <el-input v-model="baobiaoform.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="报表说明" :label-width="formLabelWidth">
              <!-- {{baobiaoform.popovertext}} -->
              <Tinymce ref="editor" v-model="baobiaoform.popovertext" :height="100" />
            </el-form-item>

            <el-form-item label="选项卡名称" :label-width="formLabelWidth" v-if="baobiaoform.tabs.length>0">
              <el-input v-model="bchild.name" v-for="bchild in baobiaoform.tabs" :key="bchild.code" style="width:50%;margin-bottom:10px"></el-input>
            </el-form-item>

            <el-form-item label="视图宽度" :label-width="formLabelWidth">
              <el-radio-group v-model="baobiaoform.width">
                <el-radio :label="6">1/4</el-radio>
                <el-radio :label="8">1/3</el-radio>
                <el-radio :label="12">1/2</el-radio>
                <el-radio :label="24">1/1</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="视图高度" :label-width="formLabelWidth">
              <el-select v-model="baobiaoform.height">
                <el-option :value="290" label="300px"></el-option>
                <el-option :value="350" label="350px"></el-option>
                <el-option :value="400" label="400px"></el-option>
                <el-option :value="450" label="450px"></el-option>
                <el-option :value="500" label="500px"></el-option>
                <el-option :value="550" label="550px"></el-option>
                <el-option :value="600" label="600px"></el-option>
                <el-option :value="650" label="650px"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFormbaocun">确 定</el-button>
          </div>
        </el-dialog>

        <el-drawer title="" size="300px" :visible.sync="drawerview" :before-close="handleCloseview">
          <el-button type="primary" style="margin-left:10px;padding: 5px 15px;" @click="yingyongliebiaoview">应用</el-button>
          <!-- <el-input v-model="gridDatasousuo" placeholder="请输入内容" prefix-icon="el-icon-search" @input="gridDatasousuoinput"></el-input> -->
          <el-table :data="gridDataview" :show-header='false' style="margin-top:30px;" :height="tableHeight">
            <el-table-column property="name" label="报表名称" width="220">
              <template slot-scope="scope">
                <div style="width:220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="scope.row[scope.column.property]">
                  {{scope.row[scope.column.property]}}
                </div>
              </template>

            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="mini" style="color:#1890ff" v-if="scope.row.selected == false" @click="viewhandleEditadd(scope.$index, scope.row)">添加</el-button>
                <el-button size="mini" style="color:#EE6363" v-if="scope.row.selected == true" @click="viewhandleEditremove(scope.$index, scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-drawer>

        <div v-if="modelList.length==0" style="position: relative">
          <div class="wubaobiao">
            <div>
              <svg-icon slot="reference" icon-class="zhuangxiang" class="icon" style="width:100px;height:100px;color:#1890ff;margin-top:10px" />
            </div>
            <div style="margin-top:10px;font-size:14px">尚未添加报表</div>
            <el-button @click="drawer = true" slot="reference" size="mini" style="margin-top:10px" v-if="addshow" icon="el-icon-circle-plus-outline">添加</el-button>
          </div>
        </div>
      </div>
      <el-row :gutter="20">
        <!--  :style='{"height":(item.hide?"40px":"auto")}' -->
        <el-col v-for="item in modelList" :key="item.code" :span="item.width" style="overflow: hidden;margin-bottom:10px;">
          <div class="grid-content" :class="item.kpiType==20?'':'bg-purple-dark'" style="float: left;width: 100%;position:relative;">
            <div v-if="item.name!=''" class="ibox-title" style="float: left;width: 100%;">
              <span v-if="titledata[item.code].title" style="float:left;" v-html="titledata[item.code].title"></span>
              <span v-else style="float:left;">
                <h5>{{ item.name }}</h5>
              </span>
              <span v-if="item.userName!=''" style="float:left;">
                <h5>（由 {{item.userName}} 分享）</h5>
              </span>

              <div style="float:right;cursor: pointer;" title="设置" v-if="item.charge">
                <svg-icon slot="reference" icon-class="chilun" @click="ialogFormopen($event,item)" class="icon" />
              </div>
              <div class="ibox-tools" style="float:right;margin-right:20px;">
                <el-popover v-model="item.popovers" placement="top-start" width="300" trigger="hover">
                  <span class="zhibiaoshuoming">
                    <span class="zhibiaoshuoming_title">数据指标说明</span>
                    <div style="max-height:45vh;overflow-y: auto;padding-right:10px" v-html="item.popovertext" ></div>
                  </span>
                  <svg-icon slot="reference" icon-class="ask" class="icon" />
                </el-popover>
              </div>

              <div style="float:right;cursor: pointer;margin-right:20px;" title="折叠">
                <svg-icon slot="reference" v-if="item.hide" icon-class="show_less" style="width:20px;height:20px;" @click="show_view($event,item)" class="icon" />
                <svg-icon slot="reference" v-if="!item.hide" icon-class="show_more" style="width:20px;height:20px;" @click="show_view($event,item)" class="icon" />
              </div>

            </div>
            <div v-else style="padding: 1px 15px 1px;" />
            <div style="float: left;width: 100%;margin-top: 10px;">

              <div class="filter-div">
                <div style="float:left">
                  <el-button icon="el-icon-plus" size="mini" type="primary" @click="addzidingyitiaojian($event,item.labelList)" style="margin-left:20px;">筛选条件</el-button>

                  <el-button icon="el-icon-finished" type="success" :disabled="item.labelList.length<1" @click="zidingyitiaojianjisuan($event,item.labelList,item,true)" size="mini"
                    :title="item.labelList.length<1?'请先添加筛选条件':'查询'">查询</el-button>
                  <el-button icon="el-icon-circle-close" type="danger" v-if="item.labelList.length>0" size="mini" @click="qingkongtiaojian($event,item.labelList,item)">清空值</el-button>
                </div>
                <!-- 筛选条件模板 -->
                <div style="float:left;width:100%;position: relative;" :class="item.labelList.length>1?'erjikuohu':''">
                  <div v-if="item.labelList.length>1" class="myaddifor">且</div>
                  <div style="float:left;width:calc(100% - 100px);" :style="item.labelList.length>1?'margin-left:60px':''">
                    <div style="padding:2px 8px;border:1px solid #dedede;border-radius:18px;margin-left:20px;line-height:30px;float:left;margin-bottom:5px;margin-top:5px" v-for="(tiaojian,tindex) in item.labelList"
                      :key="tindex">
                      <el-select v-model="tiaojian.trueField" size="mini" :disabled="tiaojian.isLock" :title="tiaojian.isLock?'请先解锁':''" @change="selectziduan($event,tiaojian,zidingyitiaojiandata[item.code])"
                        placeholder="请选择类型" style="min-width:130px;">
                        <el-option v-for="(tablesform,findex) in zidingyitiaojiandata[item.code]" :key="findex" :value="tablesform.trueField" :label="tablesform.fieldDesc"></el-option>
                      </el-select>
                      <span v-if="tiaojian.parameterType==4 || tiaojian.parameterType==5"></span>
                      <span v-else>
                        <el-select size="mini" v-model="tiaojian.jisuan" :disabled="tiaojian.isLock" style="width:70px;">
                          <el-option value="=" label="="></el-option>
                          <el-option value="!=" label="!=" disabled title="开发中"></el-option>
                          <el-option value=">" label=">" disabled title="开发中"></el-option>
                          <el-option value=">=" label=">=" disabled title="开发中"></el-option>
                          <el-option value="<" label="<" disabled title="开发中"></el-option>
                          <el-option value="<=" label="<=" disabled title="开发中"></el-option>
                        </el-select>
                      </span>
                      <span v-if="tiaojian.parameterType==1">
                        <el-input v-model="tiaojian.mohu" size="mini" :style="{'width':(tiaojian.width1)+'px'}" @change="textinput($event,tiaojian)" @input="textinput($event,tiaojian)" placeholder="模糊查询" clearable
                          style="margin-left:1px;min-width:100px;"></el-input>
                      </span>
                      <span v-else-if="tiaojian.parameterType==2">
                        <el-input v-model="tiaojian.jingque" size="mini" :style="{'width':(tiaojian.width1)+'px'}" @change="textinput($event,tiaojian)" @input="textinput($event,tiaojian)" placeholder="精确查询" clearable
                          style="margin-left:1px;min-width:100px;"></el-input>
                      </span>
                      <span v-else-if="tiaojian.parameterType==3">
                        <el-input v-model="tiaojian.qujian1" size="mini" placeholder="起始值" type="number" min="0" clearable style="margin-left:1px;width:100px;"></el-input>
                        <span>-</span>
                        <el-input v-model="tiaojian.qujian2" size="mini" placeholder="结束值" type="number" min="0" clearable style="margin-left:1px;width:100px;"></el-input>
                      </span>
                      <span v-else-if="tiaojian.parameterType==4">
                        <el-date-picker unlink-panels v-model="tiaojian.time" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="mini"
                          style="margin-left:1px;width:230px;"></el-date-picker>
                      </span>
                      <span v-else-if="tiaojian.parameterType==5">
                        <!-- <el-select v-model="timetypesarr[item.code]" @change="timetypechange($event,item)" size="mini" style="width:100px;">
                          <el-option label="七日内" value="1"></el-option>
                          <el-option label="七日前" value="2"></el-option>
                        </el-select> -->
                        <el-date-picker unlink-panels size="mini" v-model="timearr[item.code]" type="daterange" placeholder="选择日期" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :editable="false"
                          style="width:230px;">
                        </el-date-picker>
                        <!-- :picker-options="pickerOptions[item.code]" -->
                      </span>
                      <span v-else>

                        <el-cascader v-if="tiaojian.trueField == 'CHANNEL_ID'" clearable size="mini" reserve-keyword collapse-tags filterable placeholder="请选择" style="margin-left:1px;min-width:220px;"
                          v-model="tiaojian.data_select" :options="tiaojian.data_list" :props="{ expandTrigger: 'hover',multiple: true ,label:'key',value:'value',children:'children' }"
                          @visible-change="visiblechange($event,item,tiaojian)"></el-cascader>
                        <!-- multiple collapse-tags  -->
                        <el-select v-else v-model="tiaojian.data_select" size="mini" reserve-keyword multiple collapse-tags filterable placeholder="请选择" remote :remote-method="(query)=>{remoteMethod(query,tiaojian)}"
                          clearable style="margin-left:1px;min-width:200px;" @visible-change="visiblechange($event,item,tiaojian)">
                          <el-option v-for="item in tiaojian.data_list" :value="item.value" :label="item.key" :key="item.value"></el-option>
                        </el-select>

                      </span>
                      <!-- 锁定单个筛选条件 -->
                      <i style="cursor: pointer;color:#666" @click="locktiaojian($event,item,item.labelList,tiaojian)" class="el-icon-lock" v-if="tiaojian.isLock"></i>

                      <!-- 解锁单个筛选条件 -->
                      <i style="cursor: pointer;color:#666" @click="locktiaojian($event,item,item.labelList,tiaojian)" class="el-icon-unlock" v-else></i>

                      <!-- 删除单个筛选条件 -->
                      <i style="cursor: pointer;color:#F56C6C" @click="shanchutiaojian($event,item.labelList,tindex)" class="el-icon-delete" v-if="!tiaojian.isLock"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="" style="float:right;margin-right:10px;">
                <el-popover width="400" trigger="click">
                  <el-button slot="reference" size="mini" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
                  <template>
                    <div v-for="(listdis,index) in chartData[item.code].thead" :key="listdis.property">
                      <div class="shaixuanlielist" @click='tablelistdis(chartData[item.code].thead[index],chartData[item.code],item.code)' :class="chartData[item.code].thead[index].disabled?'shaixuantextcolor':''">
                        <el-checkbox v-model="chartData[item.code].thead[index].disabled" style="margin-right:5px;"></el-checkbox>{{chartData[item.code].thead[index].label}}
                      </div>
                    </div>
                  </template>
                </el-popover>
              </div>
              <div style="float:right;margin-right:10px;cursor: pointer;" title="下载">
                <span style="font-size: 12px;color:#666;" v-if="chartDataAll[item.code].page.totalCount > 20000">总条数{{chartDataAll[item.code].page.totalCount}}条(最大下载2万条)</span>
                <el-button slot="reference" size="mini" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;" @click="xiazai($event,item)">
                </el-button>
              </div>
            </div>
            <!-- <el-tag type="info" v-if="item.labelList.length==0">不选择查询条件时，默认不查询</el-tag>  :style="{'height':(parseInt(item.height)-100) +'px'}"-->
            <div style="float: left;width: 100%;overflow: hidden;min-height:600px" v-loading="modelloading[item.code]">
              <div v-if="item.kpiType == -2 && item.childs.length>0" style="width:98%;margin-left:1%;">
                <el-tabs v-model="modelact[item.childs[0].code]" type="card" style="padding-top:10px;" @tab-click="handleClick">
                  <el-tab-pane v-for="datas in item.childs" :key="datas.code" :label="datas.name" :name="datas.code" :mid="item.code" :ttype="datas.timeType" :ktype="datas.kpiType" />
                </el-tabs>
                <!-- :style="{'height':item.height}" -->
                <div :style="{'min-height':item.height}" style="border:1px solid #dedede;border-top:none;padding-top:15px;">
                  <!-- :height="(parseInt(item.height)-175) +'px'" -->
                  <el-table :style="{'min-height':item.height}" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" :data="chartData[item.code].page.result" class="tb-edit" style border
                    :empty-text="emptytext[item.code]" @sort-change="handleAgeSortChange($event,item)">
                    <el-table-column v-for="(itemtable) in chartData[item.code].thead" :key="itemtable.label" :label="itemtable.label" :property="itemtable.property" v-if="itemtable.disabled"
                      :sortable="itemtable.orderType&&itemtable.orderType!=0?'custom':false">
                      <!--,index1  :fixed="gudinglie(index1)" -->
                      <template slot-scope="scope">
                        <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                          @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                          {{scope.row[scope.column.property] | neirongsuojian}}
                        </span>
                        <span v-else>
                          {{scope.row[scope.column.property]}}
                        </span>
                      </template>
                      <el-table-column :min-width="itemtable1.width" v-for="itemtable1 in itemtable.list" :label="itemtable1.label" :key="itemtable1.label" :property="itemtable1.property" v-if="itemtable1.disabled"
                        :sortable="itemtable1.orderType&&itemtable1.orderType!=0?'custom':false">
                        <template slot-scope="scope">
                          <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                            @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                            {{scope.row[scope.column.property] | neirongsuojian}}
                          </span>
                          <span v-else>
                            {{scope.row[scope.column.property]}}
                          </span>
                        </template>
                        <el-table-column :min-width="itemtable2.width" v-for="itemtable2 in itemtable1.list" :label="itemtable2.label" :key="itemtable2.label" :property="itemtable2.property" v-if="itemtable2.disabled"
                          :sortable="itemtable2.orderType&&itemtable2.orderType!=0?'custom':false">
                          <template slot-scope="scope">
                            <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                              @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                              {{scope.row[scope.column.property] | neirongsuojian}}
                            </span>
                            <span v-else>
                              {{scope.row[scope.column.property]}}
                            </span>
                          </template>
                          <el-table-column :min-width="itemtable3.width" v-for="itemtable3 in itemtable2.list" :label="itemtable3.label" :key="itemtable3.label" :property="itemtable3.property" v-if="itemtable3.disabled"
                            :sortable="itemtable3.orderType&&itemtable3.orderType!=0?'custom':false">
                            <template slot-scope="scope">
                              <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                                @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                                {{scope.row[scope.column.property] | neirongsuojian}}
                              </span>
                              <span v-else>
                                {{scope.row[scope.column.property]}}
                              </span>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table-column>
                    </el-table-column>
                  </el-table>

                  <div class="block" style="padding-bottom:10px">
                    <el-pagination :current-page="pageNo[item.code]" :codes="item.code" :page-sizes="[20, 50,100]" :page-size="pageSize[item.code]" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5"
                      :total="chartData[item.code].page.totalCount && chartData[item.code].page.totalCount > 0?chartData[item.code].page.totalCount:0" style="margin-top:10px;"
                      @size-change="handleSizeChange($event,item.labelList,item)" @current-change="handleCurrentChange($event,item.labelList,item)" />
                  </div>
                </div>
              </div>
              <div v-else>
                <!--  :style="{'height':item.height}" -->
                <div style="padding-top:15px;">
                  <!--  :height="(parseInt(item.height)-175) +'px'" -->
                  <el-table :min-height="(parseInt(item.height)-175) +'px'" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" v-loading="modelloading[item.code]"
                    :data="chartData[item.code].page.result" class="tb-edit" :empty-text="emptytext[item.code]" border @sort-change="handleAgeSortChange($event,item)">
                    <el-table-column v-for="(itemtable) in chartData[item.code].thead" :key="itemtable.label" :label="itemtable.label" v-if="itemtable.disabled" :property="itemtable.property"
                      :sortable="itemtable.orderType&&itemtable.orderType!=0?'custom':false">

                      <!--,index1 :fixed="gudinglie(index1)" -->
                      <template slot-scope="scope">
                        <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                          @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                          {{scope.row[scope.column.property] | neirongsuojian}}
                        </span>
                        <span v-else>
                          {{scope.row[scope.column.property]}}
                        </span>
                      </template>
                      <el-table-column :min-width="itemtable1.width" v-for="itemtable1 in itemtable.list" :label="itemtable1.label" :key="itemtable1.label" :property="itemtable1.property" v-if="itemtable1.disabled"
                        :sortable="itemtable1.orderType&&itemtable1.orderType!=0?'custom':false">
                        <template slot-scope="scope">
                          <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                            @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                            {{scope.row[scope.column.property] | neirongsuojian}}
                          </span>
                          <span v-else>
                            {{scope.row[scope.column.property]}}
                          </span>
                        </template>
                        <el-table-column :min-width="itemtable2.width" v-for="itemtable2 in itemtable1.list" :label="itemtable2.label" :key="itemtable2.label" :property="itemtable2.property" v-if="itemtable2.disabled"
                          :sortable="itemtable2.orderType&&itemtable2.orderType!=0?'custom':false">
                          <template slot-scope="scope">
                            <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                              @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                              {{scope.row[scope.column.property] | neirongsuojian}}
                            </span>
                            <span v-else>
                              {{scope.row[scope.column.property]}}
                            </span>
                          </template>
                          <el-table-column :min-width="itemtable3.width" v-for="itemtable3 in itemtable2.list" :label="itemtable3.label" :key="itemtable3.label" :property="itemtable3.property" v-if="itemtable3.disabled"
                            :sortable="itemtable3.orderType&&itemtable3.orderType!=0?'custom':false">
                            <template slot-scope="scope">
                              <span v-if="scope.row[scope.column.property] && scope.row[scope.column.property].length>60" style="color:#646cf5;cursor: pointer;"
                                @click="jinruyouxi(scope.$index, scope.row,scope.column.property)">
                                {{scope.row[scope.column.property] | neirongsuojian}}
                              </span>
                              <span v-else>
                                {{scope.row[scope.column.property]}}
                              </span>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table-column>
                    </el-table-column>
                  </el-table>

                  <div class="block" style="padding-bottom:10px">
                    <el-pagination :current-page="pageNo[item.code]" :codes="item.code" :page-sizes="[20, 50,100]" :page-size="pageSize[item.code]" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5"
                      :total="chartData[item.code].page.totalCount && chartData[item.code].page.totalCount >0 ?chartData[item.code].page.totalCount:0" style="margin-top:10px;"
                      @size-change="handleSizeChange($event,item.labelList,item)" @current-change="handleCurrentChange($event,item.labelList,item)" />
                  </div>
                </div>
              </div>

            </div>

          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="返回内容" :visible.sync="adddivif" width="90%" top="5vh">
      <el-row>
        <el-col :span="24">
          <div v-if="jsonif == 'html'" style="height:500px;overflow-y: scroll">
            <json-editor ref="jsonEditor" v-html="jsontext" />
          </div>
          <div v-if="jsonif == 'json'" style="height:500px;overflow-y: scroll">
            <json-editor ref="jsonEditor" v-model="jsontext" />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button type="primary" style="float:right;margin-top:10px;margin-right:20px" @click="adddivif = false">确定</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import CountTo from "vue-count-to";
import echarts from '@Bdc~/views/gameData/components/chartPage'
import JsonEditor from '@/components/JsonEditor'
import FileSaver from "file-saver";
import XLSX from "xlsx";



import {
  ajax_modellist,
  ajax_zhibiaoliebiao,
  ajax_createView,
  ajax_updateView,
  ajax_shareduserlist,
  ajax_shareduser,
  ajax_sharedalluser,
  ajax_viewlist,
  ajax_zitiaojiandata,
  ajax_gm_handleBusinessByTargetKpi,
  customquery,
  customqueryDownload,
  ajax_modelQuery,
  ajax_lock
} from "@Gms~/api/ajax_model";
import Store from '@Sys~/store'
const name = Store.getters.currentRoute.name
export default {
  name: name,
  components: {
    Tinymce,
    CountTo,
    echarts,
    FileSaver,
    XLSX,
    JsonEditor
  },
  data() {
    return {
      productTimeZone: window.sessionStorage.getItem('productTimeZone'),
      timeguding: "",
      targetDate: "",
      usersearch: "",
      jsonif: "json",
      jsontext: {},
      adddivif: false,
      gridDataview: [],
      drawerview: false,
      addshow: true,
      sharedselectvalue: "1",
      sharedselect: [
        {
          value: "1",
          label: "仅自己可见"
        },
        {
          value: "2",
          label: "全部成员可见"
        },
        {
          value: "3",
          label: "指定成员可见"
        }
      ],
      gridDatashared: [],
      timetypes: [
        {
          value: "1D",
          label: "按天",
          disabled: false
        },
        {
          value: "1W",
          label: "按周",
          disabled: true
        },
        {
          value: "1M",
          label: "按月",
          disabled: true
        },
        {
          value: "1H",
          label: "按时",
          disabled: true
        },
        {
          value: "5m",
          label: "按分",
          disabled: true
        }
      ],
      tableHeight: window.innerHeight - 100,
      tableHeightshared: window.innerHeight - 200,
      dialogFormVisible: false,
      baobiaoform: {
        id: "",
        name: "",
        sort: "",
        height: "",
        popovertext: "",
        width: 6,
        tabs: []
      },
      formLabelWidth: "120px",
      gridDatasousuo: "",
      gridData: [],
      originalGridData: [],
      drawer: false,
      drawershared: false,
      aaa: true,
      props: {
        multiple: true,
        expandTrigger: "hover"
        // value: "value",
        // label: "key"
      },
      gameChanneId1: [],
      channelSasId1: [],
      gameServer: [],
      aaa: [],
      disyunyingqudao: 0, //是否隐藏次渠道
      selectDate: [],
      selectmodel: {},
      gameChanneId1: "",
      gameChanneId2: "",
      modelList: [], //模块列表
      chartData: {}, //模块数据
      selectchartlist: {},
      selectchartvalue: {},
      selecttimetype: {},
      titledata: {}, //模块标题
      modelloading: {}, //模块加载
      pageloading: true,
      chartDatacopy: {}, //模块数据复制
      chartDataAll: {}, //模块数据总条数
      modelact: {}, //模块组标签首位code
      currentPage: {}, //table表数据总页数
      sizePage: {}, //table表数据每页显示数
      dataLength: {}, //table表数据总条数
      modelzdata: {}, //模块子条件集合
      timetypesarr: {},//两日内外时间类型
      timearr: {},//两日内外时间值
      pickerOptions: {},//两日内外时间格式化
      emptytext: {},
      pageNo: {},
      pageSize: {},
      viewid: "",
      addtiaojian: {
        eventCode: "",
        trueField: "",
        jisuan: "=",
        colType: "",
        fieldDesc: "",
        parameterType: "",
        parameterValue: "",
        mohu: "",
        jingque: "",
        qujian1: 0,
        qujian2: 0,
        time: [],
        data_select: [],
        data_list: [],
        data_list_copy: [],
        width1: 100,
        isLock: false
      },
      zidingyitiaojiandata: {},
    };
  },
  created() {

    console.log(window.sessionStorage.getItem('productTimeZone'))
    var timezone = decodeURIComponent(window.sessionStorage.getItem('productTimeZone')).replace("UTC", ""); //目标时区时间，东八区
    var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
    var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
    this.targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);

    this.timeguding = new Date(new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 3)).getTime();
    console.log(this.timeguding)


    var menuid = this.$route.meta.id;
    this.addshow = this.$route.meta.shared;
    console.log(menuid);
    this.pageloading = true;
    // this.find_conditions_gms_16();
    ajax_modellist(menuid)
      .then(response => {
        console.log("aaaaaaaaa", response);
        if (response.code == 1) {
          this.modelList = response.data;

          var arrlist = [];
          for (var i = 0; i < this.modelList.length; i++) {
            this.modelList[i].labelList = [];
            this.$set(this.titledata, this.modelList[i].code, {});
            this.$set(this.modelloading, this.modelList[i].code, false);
            this.$set(this.chartDataAll, this.modelList[i].code, { page: { result: [], totalCount: 0 } });

            if (
              this.modelList[i].kpiType == -2 &&
              this.modelList[i].childs.length > 0
            ) {
              // 标签组
              arrlist.push({
                ids: this.modelList[i].code,
                code: this.modelList[i].childs[0].code,
                kpitype: this.modelList[i].childs[0].kpiType,
                timetype: this.modelList[i].childs[0].timeType
              });
              this.$set(this.currentPage, this.modelList[i].code, 1);
              this.$set(this.dataLength, this.modelList[i].code, 1);
              this.$set(this.sizePage, this.modelList[i].code, 20);
              this.$set(this.chartData, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
              this.$set(this.chartDatacopy, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
              this.$set(
                this.modelact,
                this.modelList[i].childs[0].code,
                this.modelList[i].childs[0].code
              );

              // 标签组
              arrlist.push({
                ids: this.modelList[i].code,
                code: this.modelList[i].childs[0].code,
                kpitype: this.modelList[i].childs[0].kpiType,
                timetype: this.modelList[i].childs[0].timeType
              });

              this.$set(
                this.modelact,
                this.modelList[i].childs[0].code,
                this.modelList[i].childs[0].code
              );
              this.$set(this.selectchartlist, this.modelList[i].code, {});
              this.$set(this.selectchartvalue, this.modelList[i].code, {});
            } else {
              this.$set(this.selectchartlist, this.modelList[i].code, {});
              this.$set(this.selectchartvalue, this.modelList[i].code, {});
              arrlist.push({
                ids: this.modelList[i].code,
                code: this.modelList[i].code,
                kpitype: this.modelList[i].kpiType,
                timetype: this.modelList[i].timeType
              });
              this.$set(this.currentPage, this.modelList[i].code, 1);
              this.$set(this.dataLength, this.modelList[i].code, 1);
              this.$set(this.sizePage, this.modelList[i].code, 20);
              this.$set(this.chartData, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
              this.$set(this.chartDatacopy, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
            }
            this.$set(this.emptytext, this.modelList[i].code, "不选择筛选条件时，默认不查询");
            this.$set(this.pageNo, this.modelList[i].code, 1);
            this.$set(this.pageSize, this.modelList[i].code, 20);
            this.$set(this.selectmodel, this.modelList[i].code, {});
            this.$set(this.zidingyitiaojiandata, this.modelList[i].code, {});
            this.$set(this.timetypesarr, this.modelList[i].code, "1");
            this.$set(this.timearr, this.modelList[i].code, [
              new Date(
                // new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 1)
                new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 2)
              ).Format("yyyy-MM-dd"),
              this.targetDate.Format("yyyy-MM-dd")
            ]);
            this.$set(this.pickerOptions, this.modelList[i].code, {
              disabledDate(time) {
                // return time.getTime() < (Date.now() - 24 * 2 * 3600 * 1000) || time.getTime() > Date.now(); //两日内
                return time.getTime() < (Date.now() - 24 * 7 * 3600 * 1000) || time.getTime() > Date.now(); // 七日内
              }
            });

            this.find_conditions_gms(this.modelList[i].code);
            // this.tiaojianlist(this.modelList[i].code);
            this.zidingyitiaojianjisuan("", [], this.modelList[i], true)
          }


        } else {
          alert(response.msg);
        }
        this.pageloading = false;
      })
      .catch(error => {
        console.log(error);
      });

    ajax_zhibiaoliebiao(menuid).then(response => {
      console.log(response);
      if (response.code == 1) {
        this.gridData = response.data;
        this.originalGridData = JSON.parse(JSON.stringify(response.data))
      } else {
        alert(response.msg);
      }
    });
    this.sharedselectvalue = this.$route.meta.status + "";
    if (this.sharedselectvalue == "3") {
      ajax_shareduserlist(this.$route.meta.id).then(
        response => {
          console.log(response);
          if (response.statusCode == 1) {
            this.gridDatashared = response.data.tbody;
          }
        }
      );
    }
  },
  mounted() { },
  methods: {

    getTextWidth(text, font) {
      // re-use canvas object for better performance
      var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement("canvas"));
      var context = canvas.getContext("2d");
      context.font = font;
      var metrics = context.measureText(text);
      return metrics.width;
    },
    textinput(e, obj) {
      obj.width1 = this.getTextWidth(e, "13px arial") + 60
    },
    timetypechange(e, obj) {
      if (e == 1) {
        this.timearr[obj.code] = [
          new Date(
            // new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 1)
            new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 6)
          ).Format("yyyy-MM-dd"),
          this.targetDate.Format("yyyy-MM-dd")
        ],
          this.pickerOptions[obj.code] = {
            disabledDate(time) {
              // return time.getTime() < (Date.now() - 24 * 2 * 3600 * 1000) || time.getTime() > Date.now(); // 两日内
              return time.getTime() < (Date.now() - 24 * 7 * 3600 * 1000) || time.getTime() > Date.now();
            },
          }
      } else if (e == 2) {
        this.timearr[obj.code] = [
          new Date(
            // new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 9)
            new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 14)
          ).Format("yyyy-MM-dd"),
          new Date(
            // new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 2)
            new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 7)
          ).Format("yyyy-MM-dd")
        ],
          this.pickerOptions[obj.code] = {
            disabledDate(time) {
              // return time.getTime() > (Date.now() - 24 * 2 * 3600 * 1000);
              return time.getTime() > (Date.now() - 24 * 7 * 3600 * 1000);
            },
          }
      }
    },
    tiaojianlist(code) {
      // 查询对应模块的筛选条件
      ajax_modelQuery(code).then(res => {
        if (res.code == 1) {
          for (var s = 0; s < this.modelList.length; s++) {
            if (this.modelList[s].code == code) {
              if (JSON.stringify(res.data) == '{}') {
                var arrData = [];
                this.zidingyitiaojiandata[code].forEach(item => {
                  if (item.parameterType == "5" || item.trueField == "ROLE_ID") {
                    arrData.push({
                      eventCode: item.eventCode,
                      trueField: item.trueField,
                      jisuan: "=",
                      colType: item.colType,
                      fieldDesc: item.fieldDesc,
                      parameterType: item.parameterType,
                      parameterValue: "",
                      mohu: "",
                      jingque: "",
                      qujian1: 0,
                      qujian2: 0,
                      time: [],
                      data_select: [],
                      data_list: [],
                      data_list_copy: [],
                      width1: 100,
                      isLock: false
                    })
                  }
                })
                this.modelList[s].labelList = arrData
              } else {
                this.modelList[s].labelList = res.data
              }
            }
          }
        }
      })
    },
    find_conditions_gms(code) {
      ajax_gm_handleBusinessByTargetKpi(
        "find_conditions_" + code,
        {}
      ).then(response => {
        console.log(code, response.data);
        if (response.code == 1) {
          this.zidingyitiaojiandata[code] = response.data;
          this.tiaojianlist(code);
        }
      });
    },
    xiazai(e, item) {

      var zidingyitiaojianobj = JSON.parse(
        JSON.stringify(item.labelList)
      );
      if (zidingyitiaojianobj.length < 1) {
        this.$message.error("请选择筛选条件");
        this.emptytext[item.code] = "不选择筛选条件时，默认不查询"
        return false;
      }
      var qtype = 1;
      var times = "";
      for (var i = 0; i < zidingyitiaojianobj.length; i++) {
        var list = zidingyitiaojianobj[i];
        if (list.parameterType == 1) {
          if (list.mohu != "") {
            list.parameterValue = list.mohu;
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 2) {
          if (list.jingque != "") {
            list.parameterValue = list.jingque;
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 3) {
          if (
            !isNaN(list.qujian1) &&
            typeof list.qujian1 == "number" &&
            !isNaN(list.qujian2) &&
            typeof list.qujian2 == "number" &&
            list.qujian2 > list.qujian1
          ) {
            list.parameterValue = list.qujian1 + " - " + list.qujian2;
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 4) {
          if (list.time != null && list.time.length > 0) {
            list.parameterValue = list.time[0] + " - " + list.time[1];
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 5) {
          console.log(list)
          // this.timetypesarr[item.code]
          if (this.timearr[item.code] != null && this.timearr[item.code].length > 0) {
            list.parameterValue = this.timearr[item.code][0] + " - " + this.timearr[item.code][1];
            times = this.timearr[item.code][0] + " - " + this.timearr[item.code][1];
            qtype = this.timetypesarr[item.code]
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else {

          if (list.data_select.length > 0) {
            if (list.trueField == "CHANNEL_ID") {
              var values = [];
              list.data_select.forEach(item => {
                values.push(item[item.length - 1])
              })
              list.parameterValue = values.join(",");
            } else {
              if (list.data_select instanceof Array) {
                list.parameterValue = list.data_select.join(",");
              } else {
                list.parameterValue = list.data_select;
              }
            }
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        }
      }
      for (var i = 0; i < zidingyitiaojianobj.length; i++) {
        delete zidingyitiaojianobj[i].jingque;
        delete zidingyitiaojianobj[i].mohu;
        delete zidingyitiaojianobj[i].qujian1;
        delete zidingyitiaojianobj[i].qujian2;
        delete zidingyitiaojianobj[i].time;
        delete zidingyitiaojianobj[i].qudao;
        delete zidingyitiaojianobj[i].qufu;
        delete zidingyitiaojianobj[i].data_list;
        delete zidingyitiaojianobj[i].data_list_copy;
        delete zidingyitiaojianobj[i].data_select;
        delete zidingyitiaojianobj[i].width1;
      }

      // this.pageNo[item.code] = 1;
      console.log(zidingyitiaojianobj);
      var datas = {
        "appkey": this.$store.getters.appkey,
        "platform": this.$store.getters.environment,
        "code": item.code,
        "pageNo": 1,
        "pageSize": 20000,
        "timeType": qtype,//1:两日内;2:两日外
        "queryTime": times,
        columns: zidingyitiaojianobj,
        thead: this.chartData[item.code].thead
      }
      console.log(datas)
      customqueryDownload(item.code, datas)
      // if (this.chartData[item.code].page.totalCount > 20000) {
      //   this.$message.warning("下载条数不能超过2万条")
      //   return false;
      // } else {
      //   customqueryDownload(item.code, datas)
      // }
    },
    zidingyitiaojianjisuan(e, obj, item, bol) {
      var zidingyitiaojianobj = JSON.parse(
        JSON.stringify(obj)
      );
      if (zidingyitiaojianobj.length < 1) {
        // this.$message.error("请选择筛选条件");
        this.emptytext[item.code] = "不选择筛选条件时，默认不查询"
        // return false;
      }
      var qtype = 1;
      var times = "";
      // var 
      for (var i = 0; i < zidingyitiaojianobj.length; i++) {
        var list = zidingyitiaojianobj[i];
        if (list.parameterType == 1) {
          if (list.mohu != "") {
            list.parameterValue = list.mohu;
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 2) {
          if (list.jingque != "") {
            list.parameterValue = list.jingque;
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 3) {
          if (
            !isNaN(list.qujian1) &&
            typeof list.qujian1 == "number" &&
            !isNaN(list.qujian2) &&
            typeof list.qujian2 == "number" &&
            list.qujian2 > list.qujian1
          ) {
            list.parameterValue = list.qujian1 + " - " + list.qujian2;
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 4) {
          if (list.time != null && list.time.length > 0) {
            list.parameterValue = list.time[0] + " - " + list.time[1];
            times = list.time[0] + " - " + list.time[1];
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else if (list.parameterType == 5) {
          console.log(list)
          // this.timetypesarr[item.code]
          if (this.timearr[item.code] != null && this.timearr[item.code].length > 0) {
            list.parameterValue = this.timearr[item.code][0] + " - " + this.timearr[item.code][1];
            times = this.timearr[item.code][0] + " - " + this.timearr[item.code][1];
            qtype = this.timetypesarr[item.code]
          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        } else {

          console.log(list.data_select)

          if (list.data_select.length > 0) {

            if (list.trueField == "CHANNEL_ID") {
              var values = [];
              list.data_select.forEach(item => {
                values.push(item[item.length - 1])
              })
              list.parameterValue = values.join(",");
            } else {
              if (list.data_select instanceof Array) {
                list.parameterValue = list.data_select.join(",");
              } else {
                list.parameterValue = list.data_select;
              }
            }

          } else {
            this.$message.error(
              list.fieldDesc + "条件错误，请确认筛选条件参数"
            );
            return false;
          }
        }
      }
      var blo = true;
      for (var i = 0; i < zidingyitiaojianobj.length; i++) {
        delete zidingyitiaojianobj[i].jingque;
        delete zidingyitiaojianobj[i].mohu;
        delete zidingyitiaojianobj[i].qujian1;
        delete zidingyitiaojianobj[i].qujian2;
        delete zidingyitiaojianobj[i].time;
        delete zidingyitiaojianobj[i].qudao;
        delete zidingyitiaojianobj[i].qufu;
        delete zidingyitiaojianobj[i].data_list;
        delete zidingyitiaojianobj[i].data_list_copy;
        delete zidingyitiaojianobj[i].data_select;


        if ((zidingyitiaojianobj[i].parameterType == 4 || zidingyitiaojianobj[i].parameterType == 5)) {
          var timevalue = zidingyitiaojianobj[i].parameterValue.split(" - ")[0].split("-")
          var commonTime = new Date(Date.UTC(timevalue[0], timevalue[1] - 1, timevalue[2], 0, 0, 0)).getTime();
          console.log(commonTime >= this.timeguding)
          if (commonTime >= this.timeguding) {
            blo = false;
          }
        } else {
          if (zidingyitiaojianobj[i].trueField == "ROLE_ID") {
            blo = false;
          } else if (zidingyitiaojianobj[i].trueField == "ROLE_KEY") {
            blo = false;
          } else if (zidingyitiaojianobj[i].trueField == "ROLE_NAME") {
            blo = false;
          } else if (zidingyitiaojianobj[i].trueField == "USER_ID") {
            blo = false;
          } else if (zidingyitiaojianobj[i].trueField == "DEVICE_ID") {
            blo = false;
          }
        }

      }
      if (blo && zidingyitiaojianobj.length > 0) {
        this.$message.warning("请选择角色相关条件！");
        return false
      }

      // ROLE_ID，ROLE_KEY， ROLE_NAME
      // 
      if (bol) {
        this.pageNo[item.code] = 1;
      }
      console.log(zidingyitiaojianobj);
      var datas = {
        "appkey": this.$store.getters.appkey,
        "platform": this.$store.getters.environment,
        "code": item.code,
        "pageNo": this.pageNo[item.code],
        "pageSize": this.pageSize[item.code],
        "timeType": qtype,//1:两日内;2:两日外
        "queryTime": times,
        columns: zidingyitiaojianobj,
        thead: this.chartData[item.code].thead

      }

      this.zaixianwanjiaqushi_init(item.code, datas);
    },
    // 清空
    qingkongtiaojian(e, arr, obj) {
      // 筛选所有锁定
      arr.forEach(element => {
        element.data_list = [] // 清除data_list
        element.data_list_copy = [] // 清除data_list
        element.mohu = ""
        element.jingque = ""
        element.qujian1 = 0
        element.qujian2 = 0
        element.time = []
        element.data_select = []
      });

    },
    // 操作+筛选条件按钮
    addzidingyitiaojian(e, obj) {
      console.log(obj)
      obj.push(JSON.parse(JSON.stringify(this.addtiaojian)));
    },
    // 监听选择类型
    selectziduan(e, obj, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].trueField == e) {
          obj.colType = arr[i].colType;
          obj.eventCode = arr[i].eventCode;
          obj.fieldDesc = arr[i].fieldDesc;
          obj.parameterType = arr[i].parameterType;
          obj.width1 = 100;
          obj.parameterValue = "";
          obj.data_select = [];
          if (arr[i].dataList && arr[i].dataList.length > 0) {
            obj.data_list = arr[i].dataList
            obj.data_list_copy = arr[i].dataList

          }
        }
      }
      console.log(obj);
    },
    // 锁定或解锁某一条筛选条件
    locktiaojian(e, item, list, son) {

      // console.log('=========', son.trueField)
      if (!son.isLock && !son.trueField) {
        this.$message({
          message: '选择类型不能为空',
          type: 'warning'
        });
        return false
      }
      son.isLock = !son.isLock
      // 循环所有筛选条件，只保存锁定
      const lockList = []
      const arr = JSON.parse(JSON.stringify(list))
      arr.forEach(element => {
        if (element.isLock) {
          element.data_list = [] // 清除data_list
          element.data_list_copy = [] // 清除data_list
          element.mohu = ""
          element.jingque = ""
          element.qujian1 = 0
          element.qujian2 = 0
          element.time = []
          element.data_select = []
          lockList.push(element)
        }
      });

      // 锁定条件 (保存) 接口
      const data = {
        appkey: this.$store.getters.appkey,
        userId: this.$store.getters.userId,
        code: item.code,
        menuId: this.$route.meta.id,
        viewId: item.id,
        rule: JSON.stringify(lockList)
      }
      ajax_lock(data).then(response => {
        if (response.code == 1) {
          this.$message({
            message: son.isLock ? '锁定成功' : '解锁成功',
            type: 'success'
          });
        }
      })

    },

    // 删除某一条筛选条件
    shanchutiaojian(e, arr, i) {
      arr.splice(i, 1);
    },

    remoteMethod(query, obj) {
      if (query !== '') {
        obj.data_list = JSON.parse(JSON.stringify(obj.data_list_copy)).filter(item => {
          return item.key.toLowerCase()
            .indexOf(query.toLowerCase()) > -1;
        });
      } else {
        if (obj.data_list_copy.length > 200) {
          obj.data_list = JSON.parse(JSON.stringify(obj.data_list_copy)).slice(0, 200)
        } else {
          obj.data_list = JSON.parse(JSON.stringify(obj.data_list_copy))
        }
      }
    },

    // 
    visiblechange(e, item, condition) {
      var bname = condition.parameterType.split(";")[0]
      var fname = condition.parameterType.split(";")[1]
      console.log(fname)
      if (fname != "" && fname != undefined) {
        var relationNames = fname.split(",")
      } else {
        var relationNames = [];
      }

      var datasvalue = "";
      for (var i = 0; i < relationNames.length; i++) {
        if (relationNames[i].indexOf("=") != -1) {
          datasvalue += relationNames[i] + "&";
        } else {
          for (var j = 0; j < item.labelList.length; j++) {
            if (relationNames[i] == item.labelList[j].parameterType.split(";")[0]) {
              if (item.labelList[j].data_select instanceof Array) {
                var values = item.labelList[j].data_select.join(",");
              } else {
                var values = item.labelList[j].data_select;
              }
              datasvalue += relationNames[i] + "=" + values + "&";
            }
          }
        }
      }
      datasvalue = datasvalue.substring(0, datasvalue.length - 1);
      console.log(datasvalue)

      if (e == true) {
        ajax_zitiaojiandata(datasvalue, bname)
          .then(response => {
            console.log(item.code + "--------------" + bname);
            if (response.code == 1) {
              var datas = response.data;
              condition.data_list_copy = JSON.parse(JSON.stringify(datas))
              if (datas.length > 200) {
                condition.data_list = datas.slice(0, 200)
              } else {
                condition.data_list = datas
              }

              // this.selectmodel[item.code][condition.name].initValues = datas;
            } else {
              if (relationNames.length > 0) {
                this.$message({
                  message: "缺少父级类型，请添加",
                  type: 'warning'
                });
              } else {
                this.$message({
                  message: response.msg,
                  type: 'warning'
                });
              }

            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    isjson(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }

        } catch (e) {
          console.log('error：' + str + '!!!' + e);
          return false;
        }
      }
    },
    jinruyouxi(index, row, property) {
      if (this.isjson(row[property])) {
        this.jsonif = "json"
        this.jsontext = JSON.parse(row[property]);
      } else {
        this.jsonif = "html"
        this.jsontext = row[property].replace(/;/g, "<br>")
      }
      this.adddivif = true;
    },
    zaixianwanjiaqushi_init(code, zitiaojian) {
      this.modelloading[code] = true;
      var this_i = this;
      // var zitiaojian = {};
      console.log(code);
      console.log(zitiaojian);

      customquery(
        code,
        zitiaojian
      ).then(response => {
        if (response.code == 1) {
          console.log(response);
          this.modelloading[code] = false;
          var heads = response.data.thead;
          var disarr = [];
          for (var i = 0; i < heads.length; i++) {
            heads[i].disabled = true;
          }
          console.log(response.data.page.result.length)
          if (response.data.page.remark != null && response.data.page.remark != "") {
            this.emptytext[code] = response.data.page.remark
          } else {
            this.emptytext[code] = "暂无数据"
          }
          response.data.thead = heads;


          this.chartDataAll[code] = JSON.parse(JSON.stringify(response.data));

          if (response.data.page.totalCount > 20000) {
            response.data.page.result.slice(0, 20000);
            response.data.page.totalCount = 20000;
          }

          this_i.chartData[code] = response.data;
          this_i.chartDatacopy[code] = JSON.parse(
            JSON.stringify(response.data)
          );
          if (zitiaojian.columns < 1) {
            this_i.chartData[code].page.result = [];
            this_i.chartDatacopy[code].page.result = [];
            this_i.pageNo[code] = 1;
            this_i.pageSize[code] = 20;
          }


        } else {
          alert(response.msg);
        }

      })
        .catch(error => {
          console.log(error);
        });
    },
    handleClick(tab, event) {
      // tab点击切换时替换图表数据
      // console.log(tab, event);
      // console.log(tab.$vnode.data.attrs.mid);
      // console.log(tab.name);

      var code = tab.$vnode.data.attrs.mid;

      this.zidingyitiaojianjisuan(
        "",
        this.modelList[code].labelList,
        this.modelList[code], true
      );
    },
    gudinglie(index) {
      // table 固定列
      if (index == "0") {
        return true;
      }
    },
    labelHead(h, { column, index }) {
      let l = column.label.length;
      let f = 16; //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
      column.minWidth = f * (l + 1); //加上一个文字长度 //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度 //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("div", { class: "table-head", style: { width: "100%" } }, [
        column.label
      ]);
    },
    handleSizeChange(e, obj, item) {
      // table 分页数量变化
      this.pageSize[item.code] = e;
      this.zidingyitiaojianjisuan(e, obj, item, false)

    },
    handleCurrentChange(e, obj, item) {
      // table 分页变化
      this.pageNo[item.code] = e;
      this.zidingyitiaojianjisuan(e, obj, item, false)
    },
    handleAgeSortChange(e, item) {
      console.log(e);
      console.log(item);
      this.chartData[item.code].thead.forEach(items => {
        if (items.orderType != 0) {
          if (e.order == "ascending") {
            items.orderType = 1       //1 or 2
          } else if (e.order == "descending") {
            items.orderType = 2       //1 or 2
          } else {
            items.orderType = 2       //1 or 2
          }
        }
      })
      this.pageNo[item.code] = 1
      this.zidingyitiaojianjisuan(e, item.labelList, item, false)
    },
    sortBy(attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }

      return function (a, b) {
        // a = a[attr];
        // b = b[attr];
        if (!isNaN(Number(a[attr])) && !isNaN(Number(b[attr]))) {
          a = Number(a[attr]);
          b = Number(b[attr]);
        } else {
          a = a[attr];
          b = b[attr];
        }

        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },
    tablelistdis(obj, arr, code) {
      if (obj.disabled == true) {
        obj.disabled = false;
      } else {
        obj.disabled = true;
      }
    },
    handleFilter() {
      // 时间选择
    },
    modelselectgameChanne(code, name) {
      console.log(code);
      console.log(name);
    },
    handleClose(done) {
      done();
    },
    handleCloseview(done) {
      done();
    },
    handleCloseshared(done) {
      done();
    },
    goaddbaobiao() {
      this.$router.push({ path: "/dataanalysis/eventanalysis" });
    },
    gridDatasousuoinput(e) {
      var arr = [];
      if (this.gridDatasousuo != "") {
        for (var i = 0; i < this.originalGridData.length; i++) {
          if (this.originalGridData[i].name.toLowerCase().indexOf(this.gridDatasousuo.toLowerCase()) != -1) {
            arr.push(this.originalGridData[i]);
          }
        }
        this.gridData = arr;
      } else {
        this.gridData = this.originalGridData;
      }
    },
    yingyongliebiao() {
      var obj = {
        menuId: this.$route.meta.id,
        menuTarget: this.$route.meta.target,
        views: [],
        type: "gms"
      };

      for (var i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].selected) {
          obj.views.push({
            kpiId: this.gridData[i].id,
            code: this.gridData[i].code
          });
        }
      }
      ajax_createView(obj).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.drawer = false;
          this.chongzhiliebiao();
        } else {
          alert(response.msg);
        }
      });
    },
    chongzhiliebiao() {
      var menuid = this.$route.meta.id;
      console.log(menuid);
      ajax_modellist(menuid)
        .then(response => {
          console.log(response);
          if (response.code == 1) {
            this.modelList = response.data;
            var arrlist = [];
            for (var i = 0; i < this.modelList.length; i++) {
              this.modelList[i].labelList = [];
              this.$set(this.titledata, this.modelList[i].code, {});
              this.$set(this.modelloading, this.modelList[i].code, false);

              if (
                this.modelList[i].kpiType == -2 &&
                this.modelList[i].childs.length > 0
              ) {
                // 标签组
                arrlist.push({
                  ids: this.modelList[i].code,
                  code: this.modelList[i].childs[0].code,
                  kpitype: this.modelList[i].childs[0].kpiType,
                  timetype: this.modelList[i].childs[0].timeType
                });
                this.$set(this.currentPage, this.modelList[i].code, 1);
                this.$set(this.dataLength, this.modelList[i].code, 1);
                this.$set(this.sizePage, this.modelList[i].code, 20);
                this.$set(this.chartData, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
                this.$set(this.chartDatacopy, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
                this.$set(
                  this.modelact,
                  this.modelList[i].childs[0].code,
                  this.modelList[i].childs[0].code
                );

                // 标签组
                arrlist.push({
                  ids: this.modelList[i].code,
                  code: this.modelList[i].childs[0].code,
                  kpitype: this.modelList[i].childs[0].kpiType,
                  timetype: this.modelList[i].childs[0].timeType
                });

                this.$set(
                  this.modelact,
                  this.modelList[i].childs[0].code,
                  this.modelList[i].childs[0].code
                );
                this.$set(this.selectchartlist, this.modelList[i].code, {});
                this.$set(this.selectchartvalue, this.modelList[i].code, {});
              } else {
                this.$set(this.selectchartlist, this.modelList[i].code, {});
                this.$set(this.selectchartvalue, this.modelList[i].code, {});
                arrlist.push({
                  ids: this.modelList[i].code,
                  code: this.modelList[i].code,
                  kpitype: this.modelList[i].kpiType,
                  timetype: this.modelList[i].timeType
                });
                this.$set(this.currentPage, this.modelList[i].code, 1);
                this.$set(this.dataLength, this.modelList[i].code, 1);
                this.$set(this.sizePage, this.modelList[i].code, 20);
                this.$set(this.chartData, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
                this.$set(this.chartDatacopy, this.modelList[i].code, { thead: [], page: { result: [], totalCount: 0 } });
              }
              this.$set(this.emptytext, this.modelList[i].code, "不选择筛选条件时，默认不查询");
              this.$set(this.pageNo, this.modelList[i].code, 1);
              this.$set(this.pageSize, this.modelList[i].code, 10);
              this.$set(this.selectmodel, this.modelList[i].code, {});
              this.$set(this.zidingyitiaojiandata, this.modelList[i].code, {});
              this.$set(this.timetypesarr, this.modelList[i].code, "1");
              this.$set(this.timearr, this.modelList[i].code, [
                new Date(
                  // new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 1)
                  new Date().setTime(this.targetDate.getTime() - 3600 * 1000 * 24 * 2)
                ).Format("yyyy-MM-dd"),
                this.targetDate.Format("yyyy-MM-dd")
              ]);
              this.$set(this.pickerOptions, this.modelList[i].code, {
                disabledDate(time) {
                  // return time.getTime() < (Date.now() - 24 * 2 * 3600 * 1000) || time.getTime() > Date.now();
                  return time.getTime() < (Date.now() - 24 * 7 * 3600 * 1000) || time.getTime() > Date.now();
                }
              });
              this.find_conditions_gms(this.modelList[i].code);

              this.zidingyitiaojianjisuan("", [], this.modelList[i], true)
            }
          } else {
            alert(response.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleEditadd(index, row) {
      for (var i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].id == row.id) {
          this.gridData[i].selected = true;
        }
      }
    },
    handleEditremove(index, row) {
      for (var i = 0; i < this.gridData.length; i++) {
        if (this.gridData[i].id == row.id) {
          this.gridData[i].selected = false;
        }
      }
    },
    userhandleEditadd(index, row) {
      for (var i = 0; i < this.gridDatashared.length; i++) {
        if (this.gridDatashared[i].id == row.id) {
          this.gridDatashared[i].locked = "1";
        }
      }
    },
    userhandleEditremove(index, row) {
      for (var i = 0; i < this.gridDatashared.length; i++) {
        if (this.gridDatashared[i].id == row.id) {
          this.gridDatashared[i].locked = "0";
        }
      }
    },
    yingyongliebiaoshared() {
      if (this.sharedselectvalue == "1") {
        var userinfo = {
          gameKey: this.$store.getters.appkey,
          userId: this.$store.getters.userId,
          menuId: this.$route.meta.id,
          users: [] //如果设置仅自己可见该参数传空集合或不传都可以
        };
        ajax_shareduser(userinfo).then(response => {
          console.log(response);
          if (response.code == 1) {
            this.$message({
              type: "success",
              message: "分享成功!"
            });
            // this.drawershared = false;
          } else {
            alert(response.msg);
          }
        });
      } else if (this.sharedselectvalue == "2") {
        ajax_sharedalluser(this.$route.meta.id).then(
          response => {
            console.log(response);
            if (response.code == 1) {
              this.$message({
                type: "success",
                message: "分享成功!"
              });
              // this.drawershared = false;
            } else {
              alert(response.msg);
            }
          }
        );
      } else if (this.sharedselectvalue == "3") {
        var userinfo = {
          gameKey: this.$store.getters.appkey,
          userId: this.$store.getters.userId,
          menuId: this.$route.meta.id,
          users: [] //如果设置仅自己可见该参数传空集合或不传都可以
        };

        var userarr = [];
        for (var i = 0; i < this.gridDatashared.length; i++) {
          if (this.gridDatashared[i].locked == "1") {
            userarr.push(this.gridDatashared[i].id);
          }
        }
        userinfo.users = userarr;
        console.log(userinfo);
        ajax_shareduser(userinfo).then(response => {
          console.log(response);
          if (response.code == 1) {
            this.$message({
              type: "success",
              message: "分享成功!"
            });
            // this.drawershared = false;
          } else {
            alert(response.msg);
          }
        });
      }
    },
    sharedselectchange(e) {
      if (e == 3) {
        ajax_shareduserlist(this.$route.meta.id).then(
          response => {
            console.log(response);
            if (response.code == 1) {
              this.gridDatashared = response.data;
            } else {
              alert(response.msg);
            }
          }
        );
      }
    },
    ialogFormopen(e, obj) {
      this.dialogFormVisible = true;
      this.baobiaoform.id = obj.id;
      this.baobiaoform.name = obj.name;
      this.baobiaoform.sort = obj.sort;
      this.baobiaoform.height = parseInt(obj.height);
      this.baobiaoform.popovertext = "";
      setTimeout(() => {
        this.baobiaoform.popovertext = obj.popovertext;
        this.$refs.editor.setContent(obj.popovertext)
      }, 100);
      this.baobiaoform.width = obj.width;
      this.baobiaoform.tabs = obj.childs;
    },
    show_view(e, obj) {
      obj.hide = !obj.hide;
      console.log(obj.hide)
    },
    yingyongliebiaoview() {
      var obj = {
        viewId: this.viewid,
        menuId: this.$route.meta.id,
        menuTarget: this.$route.meta.target,
        views: [],
        type: "gms"
      };

      for (var i = 0; i < this.gridDataview.length; i++) {
        if (this.gridDataview[i].selected) {
          obj.views.push({
            kpiId: this.gridDataview[i].id,
            code: this.gridDataview[i].code
          });
        }
      }
      ajax_createView(obj).then(response => {
        console.log(response);
        if (response.code == 1) {
          this.drawerview = false;
          this.chongzhiliebiao();
        } else {
          alert(response.msg);
        }
      });
    },
    viewhandleEditadd(index, row) {
      for (var i = 0; i < this.gridDataview.length; i++) {
        if (this.gridDataview[i].id == row.id) {
          this.gridDataview[i].selected = true;
        }
      }
    },
    viewhandleEditremove(index, row) {
      for (var i = 0; i < this.gridDataview.length; i++) {
        if (this.gridDataview[i].id == row.id) {
          this.gridDataview[i].selected = false;
        }
      }
    },
    dialogFormbaocun() {
      this.baobiaoform.height = this.baobiaoform.height + "px";
      ajax_updateView(this.baobiaoform).then(response => {
        console.log(response.data);
        if (response.code == 1) {
          this.dialogFormVisible = false;
          this.chongzhiliebiao()
        } else {
          alert(response.msg);
        }
      });
    },
    exportExcel(e, code, name) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#xiazai" + code)
      );
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.split(" ")[0] + "<br>" + value.split(" ")[1];
    },
    neirongsuojian(value) {
      return value.substring(0, 15) + "...";
    },
    ullistdata(value) {
      var vstr = value.substring(0, 1);
      if (vstr == "+") {
        var htmls =
          '<div style="display: inline-block;width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-bottom: 10px solid #00b050;margin-top:7px;margin-left:5px;"></div><span style="color:#00b050;margin-left:5px;">' +
          value +
          "</span>";
        return htmls;
      } else if (vstr == "-") {
        var htmls =
          '<div style="display: inline-block;width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-top: 10px solid #ed5565;margin-top:7px;margin-left:5px;"></div><span style="color:#ed5565;margin-left:5px;">' +
          value +
          "</span>";
        return htmls;
      } else {
        return value;
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
  min-height: calc(100vh - 100px);
}
.ibox-title {
  line-height: 28px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  font-size: 12px !important;

  // margin-top: 15px;
}
/* .el-table th{background:#fff;} */

::v-deep .el-cascader__tags .el-tag {
  max-width: 90px;
}
::v-deep .el-cascader__search-input {
  width: 20px;
  min-width: 20px;
  margin-left: 2px;
}

.filter-div {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 65%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
}
</style>

<style>
.el-tabs__item {
  height: 34px;
  line-height: 34px;
  padding-right: 15px !important;
  padding-left: 15px !important;
}

.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.el-table--medium td,
.el-table--medium th {
  padding: 6px;
}
.el-table th {
  background-color: #fff;
}
.el-table--medium th {
  padding: 6px !important;
}
.el-table--medium td {
  padding: 2px;
}

.el-radio-button .el-radio-button__inner {
  padding: 4.5px 15px;
  font-size: 16px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

.el-input.is-disabled .el-input__inner {
  color: #6d6d6d;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 5px;
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
.el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.ul {
  width: 92%;
  padding: 0;
  float: left;
  margin-left: 4%;
}
.li {
  list-style-type: none;
  width: 100%;
  float: left;
  line-height: 40px;
}
.shaixuanlielist {
  float: left;
  width: 33%;
  cursor: pointer;
  line-height: 30px;
}
.shaixuantextcolor {
  color: #46a6ff;
}
.el-drawer__header {
  margin-bottom: 0;
}
/* .el-table .cell{
  position:relative;
}
.el-table .caret-wrapper{
  position:absolute;
  top:2px;
  right:0;
}
 .el-table .cell, .el-table th div{
    padding:0!important;
  }
  .el-table tr td .cell{
    padding:5px 2px !important;
  }
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
    padding-left:0 !important;
  } */
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
/* .el-table--medium td, .el-table--medium th{
    padding: 0;
} */
.el-form-item {
  margin-bottom: 12px;
}
.myaddifor {
  position: absolute;
  left: 25px;
  top: 50%;
  height: 30px;
  margin-top: -15px;
  line-height: 30px;
  width: 30px;
  text-align: center;
  border: 1px solid #aaa;
  cursor: pointer;
  z-index: 99;
  background: #fff;
  font-size: 14px;
  color: #666;
}
.erjikuohu::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 40px;
  bottom: 22px;
  width: 30px;
  border-bottom: 1px solid #999;
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  z-index: 9;
  background: #fff;
}
</style>